import LoadingSwitchMeter from './LoadingSwitchMeter'

export default LoadingSwitchMeter
